<template>
    <div class="user-change-grant-level">
        <el-dialog title="Changement de la fonction" :visible.sync="innerVisible" size="small" :close-on-click-modal="false">

            <div v-if="establishmentData">
                <ck-form ref='role-user' label-position="top">
                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-form-item label="Fonction" style="height: 78px;">
                                <el-input type="text" v-model="form.role" auto-complete="off"></el-input>
                            </ck-form-item>
                        </el-col>
                    </el-row>

                    <div>
                        <div class="pull-right">
                            <el-button type="default" @click="cancel">Annuler</el-button>
                            <el-button type="primary" @click="end" native-type="submit">Envoyer</el-button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </ck-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.component('change-user-role-modal', {
    props: {
        userId: {
            default: () => null
        },
        zoneId: {
            default: () => null
        },
        visible: Boolean
    },
    data() {
        return {
            establishmentData: null,
            form: {
                role: '',
            },
            innerVisible: false
        }
    },
    mounted: function() {
        this.refresh();
    },
    methods: {
        refresh() {
            console.log('refresh')
            console.log('this.userId', this.userId)
            console.log('this.zoneId', this.zoneId)
            if (!this.refreshing && this.userId && this.zoneId) {
                this.refreshing = true;

                this.$http.get(`/api/user/${this.userId}/establishment/${this.zoneId}`).then((response) => {
                    console.log('response', response)
                    this.establishmentData = response.data;

                    this.form.role = this.establishmentData.Role;

                    this.innerVisible = this.visible;

                    this.refreshing = false;
                }, () => this.refreshing = false);
            }
        },
        reset() {
            this.form = {
                role: ''
            };
            this.refresh();
        },
        cancel(e) {
            this.innerVisible = false;
            this.$emit('on-cancel');
            this.reset();
        },
        end(e) {
            e.preventDefault();

            this.$refs['role-user'].validate((valid) => {
                if (valid) {
                    this.form.establishmentId = this.zoneId;

                    this.$http.post(`/api/user/${this.userId}/establishment/role`, this.form)
                        .then((response) => {
                            this.$defaultSwalApiResponse(response, () => {
                                this.$swal({
                                    type: 'success',
                                    title: 'Succès',
                                    text: 'Changement de la fonction effectué'
                                }).then(() => { });

                                this.reset();
                                this.$emit('on-save');
                                this.$root.$emit('pcr_update_data');
                                this.innerVisible = false;
                            });
                        }, this.$defaultSwalApiResponse );
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        }
    },
    watch: {
        innerVisible(val) {
            if (this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            this.innerVisible = val;
            this.reset();
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/change-user-role-modal.vue